import React from "react"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"

interface Props {
    progress: number
    pathColor: string
    trailColor: string
    textColor: string
}

function ProgressRing(props: Props) {

    return (
        <div className="DynamicFormProgressRing">
            <CircularProgressbar
                value={props.progress}
                maxValue={100}
                text={`${props.progress}%`}
                strokeWidth={4}
                styles={buildStyles({
                    rotation: 0.25,
                    strokeLinecap: 'butt',
                    textSize: "28px",
                    pathTransitionDuration: 0.5,
                    pathColor: props.pathColor,
                    textColor: props.textColor,
                    trailColor: props.trailColor,
                })}
            />
        </div>
    )
}

export default ProgressRing